import { Store } from 'redux';
import configureStoreDev from './configureStore.dev';
import configureStoreProd from './configureStore.prod';
import { StoreState } from '.';

export const configureStore: () => Store<StoreState> = process.env.NODE_ENV === 'production'
    ? configureStoreProd
    : configureStoreDev;



// WEBPACK FOOTER //
// ./src/store/configureStore.ts